import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { toast } from "sonner";
import { deleteVisitorById } from "../../api/visiteurs";
import { Visitor } from "./visitor";
import {
  Action,
  buildPermission,
  Resource,
} from "../../core/common/autorisations/permissionsMap";
import withPermission from "../../core/common/autorisations/withPermission";

interface Props {
  show: boolean;
  visitor: Visitor | null;
  onClose: () => void;
  onSuccess: () => void;
}

const VisitorDeleteModal: React.FC<Props> = ({
  show,
  visitor,
  onClose,
  onSuccess,
}) => {
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    if (!visitor) return;

    try {
      setLoading(true);
      const response = await deleteVisitorById(visitor.id);
      if (response.success) {
        toast.success("Visiteur supprimé avec succès");
        onSuccess();
        onClose();
      } else {
        toast.error(response.message || "Erreur lors de la suppression");
      }
    } catch (error: any) {
      // console.error(error);
      toast.error(error.message || "Erreur lors de la suppression du visiteur");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered size="sm">
      <Modal.Header closeButton className="border-0 pb-0 pt-4 px-4">
        <Modal.Title className="fw-bold text-danger">
          <i className="ti ti-trash me-2"></i>
          Confirmer la Suppression
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="px-4 py-3">
        <p className="mb-0">
          Êtes-vous sûr de vouloir supprimer définitivement le visiteur{" "}
          <strong className="text-dark">{`${visitor?.firstname} ${visitor?.lastname}`}</strong>{" "}
          ?
        </p>
        <p className="text-muted small mt-2">Cette action est irréversible.</p>
      </Modal.Body>

      <Modal.Footer className="border-0 px-4 pb-4 pt-0">
        <Button
          variant="danger"
          className="rounded-2 px-4 w-100"
          onClick={handleDelete}
          disabled={loading}
        >
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2"></span>
              Suppression...
            </>
          ) : (
            "Supprimer"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default withPermission(
  VisitorDeleteModal,
  [buildPermission(Resource.VISITOR, Action.DELETE)],
  "masquer",
);
